import React from "react";
import { styled } from "@material-ui/styles";
import { Card } from "@material-ui/core";
import { ReactComponentLike } from "prop-types";
import { Form as FormikForm } from "formik";
import Typography from "../typography";
import Button from "../button";
import { Theme } from "@material-ui/core";

const PageContainer = styled("div")<Theme>(({ theme }) => ({
  background: theme.palette.extra.backgroundGrey,
  minHeight: "100vh",
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(6),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
}));

const StyledCard = styled(Card)<Theme>(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: "18px",
  padding: theme.spacing(4),
  boxShadow: "0 1px 3px rgba(16, 21, 26, 0.06)",
  border: `1px solid ${theme.palette.extra.borderColor}`,
  maxWidth: "600px",
  margin: "0 auto",
  marginBottom: theme.spacing(3),
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    borderRadius: "16px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

export const UnauthenticatedLayout: ReactComponentLike = ({ children }) => {
  return (
    <PageContainer>
      <StyledCard>{children}</StyledCard>
    </PageContainer>
  );
};

export const VerticalForm = styled(FormikForm)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const Title = styled(({ children }) => (
  <Typography.H5>{children}</Typography.H5>
))<Theme>(({ theme }) => {
  const { md } = theme.breakpoints.values;

  return {
    marginBottom: 23,
    [`@media (max-width: ${md}px)`]: {
      marginBottom: 27,
    },
  };
});

export const ActionButton = styled((props) => (
  <Button type="submit" size="large" {...props} />
))<Theme>(({ theme }) => {
  const { md } = theme.breakpoints.values;
  return {
    marginTop: 24,
    width: "100%",
    padding: "12px 32px",
    fontSize: "1rem",
    fontWeight: 600,
    borderRadius: "12px",
    background: theme.palette.primary.main,
    transition: "background 0.2s ease",
    "&:hover": {
      background: theme.palette.primary.dark,
    },
    [`@media (max-width: ${md}px)`]: {
      marginTop: 20,
      padding: "10px 24px",
    },
  };
});
